import React from 'react'
import PropTypes from 'prop-types'

import routes from 'src/lib/rails-routes/rails-routes'
import { Grid, Box } from '@chatterbug/aaron'
import { Button } from '@chatterbug/theme'
import { t } from 'src/lib/i18n-react'

const createText = () => {
  const text = t(
    'Take our <strong>placement test</strong> based on which type of learner you are'
  )
  return { __html: text }
}
const PlacementTestChooser = ({ levels, languageCode, isSignup }) => {
  return (
    <Grid gridGap="2x" justifyItems="center">
      <Box textAlign="center" as="p" dangerouslySetInnerHTML={createText()} />
      <Grid gridGap="2x" minWidth="200px" maxWidth="100%">
        {levels.map((level, index) => (
          <Button
            as="link"
            presetColor="pink"
            key={index}
            type="ctaTheme2"
            fill="solid"
            href={
              isSignup
                ? routes.survey(languageCode, {
                    redirectTo: routes.placement(languageCode, {
                      start: level.start,
                    }),
                  })
                : routes.placement(languageCode, { start: level.start })
            }
          >
            {level.name}
          </Button>
        ))}
      </Grid>
    </Grid>
  )
}

PlacementTestChooser.propTypes = {
  levels: PropTypes.array.isRequired,
  languageCode: PropTypes.string.isRequired,
  isSignup: PropTypes.bool,
}

export default PlacementTestChooser
